
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import { createSelector } from "reselect";
import Zergling from '../../../helpers/zergling';
import { UpdatePlayerCardId, ClearCardRegistered, RegisterMode } from "../../../actions/terminal";
import { OpenPopup, ClosePopup } from "../../../actions/ui";
import { store } from "../../../index/terminalApp";

export function updateFromCSharp (params, bool) {
    let token = JSON.parse(sessionStorage.getItem("authData")).token,
        data = JSON.parse(params),
        textForSuccess = 'Card succesfully updated',
        textCode;

    if (bool) {
        Zergling.get({"token": token,
            "user_info": {
                "Id": data.Id,
                "FirstName": data.Name,
                "LastName": data.Surname,
                "Email": data.Email,
                "DocNumber": data.CNP,
                "MobileNumber": data.Phone,
                "Rfid": data.CardId,
                "CurrencyId": "RON",
                "BTag": data.BTag,
                "RegionId": 189
            }}, "terminal_update_player")
            .then((response) => {
                textCode = response.text_code;
                if (response.text_code === "0") {
                    store.dispatch(OpenPopup('dmsSetPinCode', { rfid: data.CardId }));
                    //store.dispatch(OpenPopup('dmsSuccess', {body: textForSuccess}));
                } else {
                    store.dispatch(OpenPopup('failPopup', {textCode}));
                }

            })
            .catch(error => console.warn(error));
    }
}

class DmsRegUpdateConfirmation extends Component {
    constructor (props) {
        super(props);
        this.updateUserInfo = this.updateUserInfo.bind(this);
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    registerPopupForDms () {
        return () => {
            this.props.closePopup()();
            this.props.dispatch(RegisterMode(false));
            this.props.dispatch(ClearCardRegistered());
        };
    }

    updateUserInfo () {
        let {Name, Surname, CNP, Email, Phone, CardId, Id, BTag} = this.props;
        //let token = JSON.parse(sessionStorage.getItem("authData")).token;
        this.props.dispatch(UpdatePlayerCardId(JSON.stringify({Name, Surname, CNP, Email, Phone, CardId, Id, BTag})));
        return this.props.closePopup()();
    }
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.CardUpdated

        ],
        CardUpdated => {
            return {
                CardUpdated
            };
        }
    );
};

DmsRegUpdateConfirmation.propTypes = {
    closePopup: PropTypes.func,
    Id: PropTypes.number,
    Name: PropTypes.string,
    Surname: PropTypes.string,
    CNP: PropTypes.string,
    Email: PropTypes.string,
    Phone: PropTypes.string,
    CardId: PropTypes.string
};

export default connect(mapStateToProps)(UIMixin({Component: DmsRegUpdateConfirmation}));